"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddBasketOfferPurchaseEvent = exports.Name = exports.AddBasketOffer = void 0;
const Name = exports.Name = 'add-basket-offer';
const AddBasketOffer = exports.AddBasketOffer = Name;
const isAddBasketOfferPurchaseEvent = event => typeof event.detail === 'object' && Boolean(event.detail.items);
exports.isAddBasketOfferPurchaseEvent = isAddBasketOfferPurchaseEvent;
